import moment from "moment";
import Vue from "vue";

Vue.filter('formatDate', function (value) {
    if (value) {
        if (typeof value === 'object' && value.date)
            return moment(String(value.date)).format('DD/MM/YYYY H:mm:ss')

        return moment(String(value)).format('DD/MM/YYYY H:mm:ss')
    }
});
Vue.filter('idNameToValueLabel', function (value) {
    if (value && Array.isArray(value)) {
        return value.map(ent => {
            return {
                label: ent.name,
                value: ent.id
            }
        })
    }
    return []
});
Vue.filter('idNameToValueText', function (value) {
    if (value && Array.isArray(value)) {
        return value.map(ent => {
            return {
                text: ent.name,
                value: ent.id
            }
        })
    }
    return []
});
Vue.filter('nl2br', function (str) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1$2');
});
